import { MASCOT_IMG_LINKS } from '../../../../../assets';


/**------------------------------------------------------
 * Event Mascots / Banners
 */
export enum EnumEventBanner {
	Birthday 		= 'birthday',
	Christmas 		= 'christmas',
	NewYear 		= 'new_year',
	Halloween 		= 'halloween',
	Eastern 		= 'eastern',
	None			= 'none'
}

export enum EnumBannerType {
	Discount 		= 'banner_type_discount',
	Mascot 			= 'banner_type_mascot',
	Message 		= 'banner_type_message'
}


/**------------------------------------------------------
 * Theme Configurations
 */
export const EVENT_BANNER_THEMES: IEventBannerTheme[] = [
	{
		code			: EnumEventBanner.Christmas,
		content			: {
			bannerType		: EnumBannerType.Discount,
			mascot			: MASCOT_IMG_LINKS.CHRISTMAS_CANDY,
			text			: 'MERRY CHRISTMAS!',
			couponCode		: 'FLY',
			couponDiscount	: 20
		}
	},
	{
		code			: EnumEventBanner.NewYear,
		content			: {
			bannerType		: EnumBannerType.Discount,
			mascot			: MASCOT_IMG_LINKS.CHRISTMAS_CANDY,
			text			: 'HAPPY NEW YEAR!',
			couponCode		: 'FLY',
			couponDiscount	: 20
		}
	},
	{
		code			: EnumEventBanner.Birthday,
		content			: {
			bannerType		: EnumBannerType.Discount,
			mascot			: MASCOT_IMG_LINKS.BIRTHDAY,
			text			: 'CELEBRATING 1st BDAY!',
			couponCode		: 'BDAY30',
			couponDiscount	: 30
		}
	}
];


/**------------------------------------------------------
 * Interfaces
 */
export interface IEventBannerTheme {
	code			: EnumEventBanner;
	content			: IEventBannerDiscount | IEventBannerMascot | IEventBannerMessage;
}

interface IEventBannerDiscount {
	bannerType		: EnumBannerType.Discount;
	mascot			: string;
	text			: string;
	couponCode		: string;
	couponDiscount	: number;
}

interface IEventBannerMascot {
	bannerType		: EnumBannerType.Mascot;
	mascot			: string;
}

interface IEventBannerMessage {
	bannerType		: EnumBannerType.Message;
	mascot			: string;
	text			: string;
}
